module.exports = __webpack_public_path__ + "img/fondo-banner-principal.deeb948a.png";